import { Box, Button, Card, Container, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import api from "../../../components/services/api";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import mime from "mime";
import { saveAs } from "file-saver";

export default function SaleOrderMac5Report() {
  const [dateStart, setDateStart] = useState(new Date());
  const [dateEnd, setDateEnd] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);

  const columns = [
    { field: "BookingNo", headerName: "Booking No.", width: 200 },
    { field: "BranchCode", headerName: "Branch Code", width: 200 },
    { field: "ContainerNo", headerName: "Container No", width: 200 },
    { field: "CustomerMAC5Code", headerName: "Customer MAC5 Code", width: 200 },
    {
      field: "ETDGateOut",
      headerName: "ETD GateOut",
      width: 200,
      renderCell: (value) => {
        return moment(value.row.ETDGateOut).format("yyyy/MM/DD");
      },
    },
    { field: "PortOfDischarge", headerName: "Port Of Discharge", width: 200 },
    { field: "Qty", headerName: "Qty", width: 200 },
    { field: "QtySizeType", headerName: "Qty Size Type", width: 200 },
    { field: "RouteCode", headerName: "Route Code", width: 200 },
    { field: "SaleOrderNo", headerName: "SaleOrder No", width: 200 },
    { field: "ServiceName", headerName: "Service Name", width: 200 },
    { field: "ServiceNo", headerName: "Service No", width: 200 },
    { field: "ShipperRefNo", headerName: "Shipper RefNo", width: 200 },
    { field: "VoyOut", headerName: "VoyOut", width: 200 },
  ];

  const search1 = async () => {
    const params = new URLSearchParams();
    if (dateStart)
      params.append("startDate", moment(dateStart).format("yyyy-MM-DD"));
    if (dateEnd) params.append("endDate", moment(dateEnd).format("yyyy-MM-DD"));
    if (searchText) params.append("keyword", searchText);
    const data = await api.get(
      `/api/report/saleorder-mac5/list?${params}`
    );

    const result = data?.data.map((item, i) => {
      return {
        ...item,
        index: i + 1,
      };
    });

    setData(result);
  };

  const getdata = async () => {
    const params = new URLSearchParams();
    if (dateStart)
      params.append("startDate", moment(dateStart).format("yyyy-MM-DD"));
    if (dateEnd) params.append("endDate", moment(dateEnd).format("yyyy-MM-DD"));
    const data = await api.get(
      `/api/report/saleorder-mac5/list?${params}`
    );

    const result = data?.data.map((item, i) => {
      return {
        ...item,
        index: i + 1,
      };
    });
    setData(result);
  };

  useEffect(() => {
    getdata();
  }, []);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายงาน Sale Order (MAC-5)
        </h6>
        <h3 style={{ marginTop: "10px" }} className="textcolordarkblue">
          Sale Order (MAC-5) Report
        </h3>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <TextField
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="small"
            id="outlined-basic"
            label="Search"
            variant="outlined"
          />

          <DesktopDatePicker
            label="Date Start"
            value={dateStart}
            onChange={(newValue) => {
              setDateStart(moment(newValue).format("yyyy-MM-DD"));
            }}
            inputFormat="yyyy/MM/dd"
            minDate={new Date("2017-01-01")}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />

          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
            }}
            onClick={search1}
          >
            <SearchIcon />
          </Button>
          <Button
            variant="contained"
            style={{
              textTransform: "none",
              backgroundColor: "#007BFF",
              marginLeft: "10px",
            }}
            onClick={async () => {
              setLoading(true);
              const params = new URLSearchParams();

              if (dateStart)
                params.append(
                  "startDate",
                  moment(dateStart).format("yyyy-MM-DD")
                );
              if (dateEnd)
                params.append("endDate", moment(dateEnd).format("yyyy-MM-DD"));
              if (searchText) params.append("keyword", searchText);
              await api
                .get(`/api/report/saleorder-mac5/download?${params}`, {
                  responseType: "blob",
                  timeout: 50000,
                })
                .then((blobFile) => {
                  const blobFileRes = new File([blobFile?.data], "test.xlsx", {
                    type: mime.getType(".xlsx"),
                  });

                  // window.open(
                  //   URL.createObjectURL(blobFileRes, "test.csv"),
                  //   "_blank"
                  // );
                  saveAs(blobFileRes, "Sale Order (MAC-5) Report.xlsx");
                  setLoading(false);
                });
            }}
          >
            Download
          </Button>
        </div>
        <Box sx={{ height: "700px", marginTop: "25px" }}>
          <DataGrid
            getRowId={(r) => r.index}
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
          />
        </Box>
      </Card>
    </LocalizationProvider>
  );
}
